'use client'

import { ButtonGhost } from 'fukku/Button/Ghost'
import { MODAL_TYPE, Modal, type ModalAPI } from 'fukku/Modal'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useColors } from 'pdp/src/contexts/ColorsProvider/ColorsProvider'
import type { Color, FullProduct, Look } from 'pdp/src/types/FullProduct'
import { ProductLocations } from 'product/types/ProductLocations'
import { useRef } from 'react'
import { applyStylesIf, cx } from 'utils/cx'

import { ColorList } from '../ColorList/ColorList'
import { REDUCED_COLOR_LIST_MAX_LENGTH } from '../ColorsSelector'

import styles from './SheetColorsSelector.module.scss'
import texts from 'fukku/styles/texts.module.scss'

export interface SheetColorsSelectorProps {
	product: FullProduct
	look: Look
	searchParams: Record<string, string>
}

export const SheetColorsSelector = ({
	product,
	look,
	searchParams,
}: SheetColorsSelectorProps) => {
	const { colors, selectedColor } = useColors()
	const { t } = useLabels()
	const modalRef = useRef<ModalAPI>(null)

	const openSheet = () => {
		modalRef.current?.show()
	}

	const isColorListReducedSelected: boolean = colors
		.slice(0, REDUCED_COLOR_LIST_MAX_LENGTH - 1)
		.some((color: Color) => color.id === selectedColor.id)

	return (
		<>
			<ButtonGhost
				className={styles.moreButton}
				onClick={openSheet}
				aria-label={t('accessibility.pdp.addColor.seeMore')}
			>
				<span
					data-testid='sheetColorsSelector.label.more'
					className={cx(
						styles.more,
						applyStylesIf(!isColorListReducedSelected, styles.selected)
					)}
				>
					<span>+{colors.length - REDUCED_COLOR_LIST_MAX_LENGTH + 1}</span>
				</span>
			</ButtonGhost>
			<Modal
				name='colorsSelectorSheet'
				data-testid='colorsSelectorSheet'
				ref={modalRef}
				type={MODAL_TYPE.SHEET_SMALL}
				title={selectedColor.label}
				showTitle={false}
				className={texts.titleM}
			>
				<p className={texts.bodyM}>{selectedColor.label}</p>
				<ColorList
					product={product}
					look={look}
					searchParams={searchParams}
					location={ProductLocations.ColorSelectorSheet}
				/>
			</Modal>
		</>
	)
}
